module.exports = __webpack_public_path__ + "img/total-new.5c08eb3d.png";